module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"tree-with-birds\"-in-pomona-california-bd5dd9d0df293e9f99b014681d3259d3.png";